import React from 'react';
import { Provider } from 'react-redux';
import { MenuProvider } from 'react-native-popup-menu'; // TODO: need to remove
import { createTheme, ThemeContext } from '@hmsexp/component-library';
import ReactDOM from 'react-dom';
import { StatusBar, SafeAreaView, StyleSheet } from './components/Common/react-native-components';
import ConnectedIntlProvider from './ConnectedIntlProvider';
import { getMergedInititalState } from './reducers/initialState';
import AppRoutes from './AppRoutes';
import configureStore from './store';
import Analytics from '../../common/utils/analyticsUtil';
import Popover from '../../common/components/Popover';

const analyticsTarget = process.env.CLIENT === 'CHINA' ? 'Umeng' : 'GA';
Analytics.initializeAnalyticsTarget({
  analyticsTarget: analyticsTarget,
  trackingIDUA: process.env.GA_TRACKING_ID,
  trackingIdGA4: process.env.GA4_TRACKING_ID
});

const styles = StyleSheet.create({
  safeAreaView: {
    flex: 1
  }
});

const actionCenter = (containerId, props) => {
  const { sharedState } = props;
  const theme = createTheme({ theme: 'light' });
  const initialState = getMergedInititalState({
        app: {
          selectedHotelId: sharedState.activeHotelId,
          userDetails: sharedState.userDetails,
          hotels: sharedState.hotels,
          currencySymbol: sharedState.currencySymbol
        }
      })
  const store = configureStore(initialState);

  ReactDOM.render(
    <Provider store={store}>
      <ConnectedIntlProvider>
        <ThemeContext.Provider value={theme}>
          <MenuProvider>
            <SafeAreaView style={styles.safeAreaView}>
              <StatusBar barStyle='dark-content' />
              <AppRoutes activeHotelId={sharedState?.activeHotelId} />
            </SafeAreaView>
          </MenuProvider>
          <Popover />
        </ThemeContext.Provider>
      </ConnectedIntlProvider>
    </Provider>,
    document.getElementById(containerId)
  );
};

window.renderTaskManager = actionCenter;
window.unmountTaskManager = containerId => {
  if (containerId && document.getElementById(containerId)) {
    ReactDOM.unmountComponentAtNode(document.getElementById(containerId));
  }
};

if (!document.getElementById('TaskManager-container')) {
  actionCenter('root', {
    sharedState: {}
  });
}
